import * as Yup from 'yup';
import { isAddress, isWalletAddress } from '../../utilities/address';
import { is_contact_name_unique, is_contact_address_unique } from '../../services/account';
import debounce from 'lodash.debounce';

function contactValidation(formData) {
  const schema = Yup.object().shape({
    name: Yup.string()
      .required('Contact Name is required')
      .test('unique_name', 'Contact name must be unique', async (contactName) => {
        if (formData.type === 'Update' && formData.current_name === contactName) return true;
        if (contactName) {
          const response = await debouncedApiContactName(formData, contactName.trim());
          if (!response) return true;
          return response.data?.data?.available;
        }
      }),
    address: Yup.string()
      .required('Contact Address is required')
      .test('test-w3address', 'The address is not valid', (value) => isAddress(value))
      .test('unique_address', 'The address must be unique', async (address) => {
        if (formData.type === 'Update' && formData.current_address === address) return true;
        if (address) {
          const response = await debouncedApiContactAddress(formData, address.trim());
          if (!response) return true;
          return response.data?.data?.available;
        }
      }).test('is_address', 'The address is not valid', async (address) => {
        return isWalletAddress(address);
      }),
    chain: Yup.array().required('Chain is required'),
    contactCategory: Yup.array().required('Contact category is required'),
    walletType: Yup.array().required('Wallet type is required'),
    acceptedAssets: Yup.array().required('Accepted address is required'),
  });
  return schema;
}

const debouncedApiContactName = debounce(is_contact_name_unique, 500);

const debouncedApiContactAddress = debounce(is_contact_address_unique, 500);

export { contactValidation };
